<template>
        <!-- Features -->
    <div id="features" class="tabs">
        <div class="container" style="padding-bottom:2em;">
            <div class="row">
                <div class="col-lg-12">
                    <img style="width:200px; padding-bottom:0.5em;" src="../assets/images/kickstarter.png"/>
                    <h2>Collaboration with</h2>
                    <img class="dhd_logo" style="padding-bottom:0.5em;" src="../assets/images/Horizontal DHD Logo for Dark Backgrounds.png"/>
                </div> <!-- end of col -->
            </div> <!-- end of row -->
            <div class="row">
                <ul class="nav nav-tabs" id="lenoTabs" role="tablist">
                    <li class="nav-item">
                        <div class="card card-body">
                            <img @click="chooseDice('blue')" v-bind:class="[dice == 'blue' ? 'active' : '']" class="wood-swatch" src="../assets/images/blue_dice_swatch.png"/>
                            <span class="wood-text">Avalore<br/>Sea Witch</span>
                        </div>
                   </li>
                   <li class="nav-item">
                        <div class="card card-body">
                            <img @click="chooseDice('orange')" v-bind:class="[dice == 'orange' ? 'active' : '']" class="wood-swatch" src="../assets/images/orange_dice_swatch.png"/>
                            <span class="wood-text">Avalore<br/>Samhain</span>
                        </div>
                   </li>
                   <li class="nav-item">
                        <div class="card card-body">
                            <img @click="chooseDice('purple')" v-bind:class="[dice == 'purple' ? 'active' : '']" class="wood-swatch" src="../assets/images/purple_dice_swatch.png"/>
                            <span class="wood-text">Avalore<br/>Mischief</span>
                        </div>
                   </li>
                   <li class="nav-item">
                        <div class="card card-body">
                            <img @click="chooseDice('copper')" v-bind:class="[dice == 'copper' ? 'active' : '']" class="wood-swatch" src="../assets/images/copper_dice_swatch.png"/>
                            <span class="wood-text">Mythica<br/>Battleworn Copper</span>
                        </div>
                   </li>
                    <li class="nav-item">
                        <div class="card card-body">
                            <img @click="chooseDice('stone')" v-bind:class="[dice == 'stone' ? 'active' : '']" class="wood-swatch" src="../assets/images/stone_dice_swatch.png"/>
                            <span class="wood-text">Mythica<br/>Dark Iron</span>
                        </div>
                   </li>
                </ul>
            </div>
            <!-- <div class="row">
                <div class="col-lg-12" style="font-style:italic;">* stretch goals</div>
            </div> -->
        </div> <!-- end of container --> 
        <!-- <img class="img-fluid" :src="woodUrl"> -->
    </div> <!-- end of tabs -->
    <!-- end of features -->
</template>

<script>

export default {
  name: 'Dice',
  data() {
      return {
        dice: 'todo',
        // diceUrl: require('../assets/images/Wood_Banner_Maple.png'),
      }
  },
  methods: {
    chooseDice (dice) {
        // this.dice = dice
        // if (dice=='copper')
        //     this.diceUrl = require('../assets/images/Wood_Banner_Maple.png')
        // else if (dice=='purpleHeart')
        //     this.diceUrl = require('../assets/images/Wood_Banner_PurpleHeart.png')
        // else if (dice=='blackWalnut')
        //     this.diceUrl = require('../assets/images/Wood_Banner_BlackWalnut.png')
        // else if (dice=='padauk')
        //     this.diceUrl = require('../assets/images/Wood_Banner_Padauk.png')
        // else if (dice=='monkeyPod')
        //     this.diceUrl = require('../assets/images/Wood_Banner_MonkeyPod.png')
    }
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Dice.vue